/* eslint-disable */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "@/css/reset.css";
import Toast from './components/Toast/toast' 
import Loading from './components/Loading/loading'

Vue.use(Toast)
Vue.use(Loading)
Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
